import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState } from 'react';
import { HeaderDataContext } from '../context/header-data-context';
import { jsx as _jsx } from "react/jsx-runtime";
export var HeaderDataContextProvider = function HeaderDataContextProvider(_ref) {
  var children = _ref.children,
      value = _ref.value;

  var _useState = useState(value === null || value === void 0 ? void 0 : value.currentPath),
      currentPath = _useState[0],
      setCurrentPath = _useState[1];

  useEffect(function () {
    setCurrentPath((value === null || value === void 0 ? void 0 : value.currentPath) || document.location.pathname);
  }, [value === null || value === void 0 ? void 0 : value.currentPath]);
  return /*#__PURE__*/_jsx(HeaderDataContext.Provider, {
    value: value ? _objectSpread(_objectSpread({}, value), {}, {
      currentPath: currentPath
    }) : null,
    children: children
  });
};